import {SpanCalculator} from "./spanCalculator";
import {SpanPositionsCalculator} from "./spanPositionsCalculator";
import {maxAllowedElementLength} from "../../../models/floor/mteFloor";
import {SectionsCalculator} from "./sectionsCalculator";

/*
* Nimmer ein Array an Dachkonfigurationen an und berechnet für jedes die Spannweiten und daraus resultierenden Deckenstärken.
* Zurückgegeben wird anschließend die optimale Konfiguration mit möglichst geringer Deckenstärke und Spannweite.
* */

export class RoofSectionsCalculator {
    constructor(roofConfiguration, raehme) {
        this.raehme = raehme;
        let roofSections = [];

        let roof = roofConfiguration.roof;
        let roofOrientation = roofConfiguration.orientation;
        let roofThickness = roofConfiguration.thickness;
        let roofOverhang = roofConfiguration.overhang;
        let depth = roof.userData.depth;
        let depthWithOverhang = depth + (2 * roofOverhang);

        roof.translateY(-roofThickness);//Temporär, Deckenhöhe reduzieren um Schnitte berechnen zu können

        try {
            //Berechnung der Positionen an denen die Decke aufliegt im 90° Winkel zur Laufrichtung der Decke
            let roofSpanPositionsCalculator = new SpanPositionsCalculator(roof, roofOrientation, this.raehme);
            let spanPositions = roofSpanPositionsCalculator.getSpanRelevantPositions();

            let spanCalculator = new SpanCalculator(roofConfiguration, this.raehme, spanPositions);
            let spans = spanCalculator.calculateSpansFromPositions();

            //Berechnen der einzelnen Dachstücke: Unter 13.5m nur eine notwendig. Darüber müssen die Teilstücke unter Einbezug des Dachüberstands berechnet werden
            if (depthWithOverhang > maxAllowedElementLength) {
                console.warn("Maximale Elementlänge wurde in Dachrichtung: " + (roofOrientation === 2 ? "x" : "z") + " überschritten.");
                let roofSectionCalculator = new SectionsCalculator(spans, spanPositions, roofOverhang, roofOrientation);
                roofSections = roofSectionCalculator.calculateSectionDepths();
            } else {
                roofSections.push(depthWithOverhang);
            }
        } catch (e) {
            console.error(e);
        }

        return roofSections;
    }
}
